import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ProcessPhase = ({ phase, index, isLast }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="relative">
      {!isLast && (
        <div className="absolute left-6 top-20 bottom-0 w-0.5 bg-border md:left-8 lg:left-10" />
      )}
      <div className="relative flex gap-4 md:gap-6 lg:gap-8">
        <div className="flex-shrink-0">
          <div className={`w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 rounded-full flex items-center justify-center transition-all duration-300 ${
            isExpanded ? 'bg-primary text-primary-foreground shadow-lg' : 'bg-card border-2 border-border text-muted-foreground'
          }`}>
            <Icon name={phase?.icon} size={24} className="md:w-8 md:h-8 lg:w-10 lg:h-10" />
          </div>
        </div>

        <div className="flex-1 pb-8 md:pb-12 lg:pb-16">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-full text-left group"
            aria-expanded={isExpanded}
          >
            <div className="flex items-start justify-between gap-4 mb-2 md:mb-3 lg:mb-4">
              <div>
                <div className="text-xs md:text-sm font-medium text-primary mb-1 md:mb-2">
                  Phase {index + 1}
                </div>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-headline font-semibold text-foreground group-hover:text-primary transition-colors duration-200">
                  {phase?.title}
                </h3>
              </div>
              <Icon 
                name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
                size={24} 
                className="text-muted-foreground group-hover:text-primary transition-all duration-200 flex-shrink-0"
              />
            </div>
            
            <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-3 md:mb-4">
              {phase?.description}
            </p>
            
            <div className="flex items-center gap-4 md:gap-6 text-xs md:text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <Icon name="Clock" size={16} />
                <span>{phase?.duration}</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={16} />
                <span>{phase?.deliverables?.length} Deliverables</span>
              </div>
            </div>
          </button>

          {isExpanded && (
            <div className="mt-4 md:mt-6 lg:mt-8 space-y-4 md:space-y-6 animate-in fade-in slide-in-from-top-2 duration-300">
              <div className="bg-card border border-border rounded-lg p-4 md:p-6 lg:p-8">
                <h4 className="text-base md:text-lg font-semibold text-foreground mb-3 md:mb-4 flex items-center gap-2">
                  <Icon name="Package" size={20} />
                  Key Deliverables
                </h4>
                <ul className="space-y-2 md:space-y-3">
                  {phase?.deliverables?.map((deliverable, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <Icon name="CheckCircle2" size={18} className="text-success flex-shrink-0 mt-0.5" />
                      <span className="text-sm md:text-base text-foreground">{deliverable}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-card border border-border rounded-lg p-4 md:p-6 lg:p-8">
                <h4 className="text-base md:text-lg font-semibold text-foreground mb-3 md:mb-4 flex items-center gap-2">
                  <Icon name="Users" size={20} />
                  Client Involvement
                </h4>
                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                  {phase?.clientInvolvement}
                </p>
              </div>

              {phase?.tools && phase?.tools?.length > 0 && (
                <div className="bg-card border border-border rounded-lg p-4 md:p-6 lg:p-8">
                  <h4 className="text-base md:text-lg font-semibold text-foreground mb-3 md:mb-4 flex items-center gap-2">
                    <Icon name="Wrench" size={20} />
                    Tools & Technologies
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {phase?.tools?.map((tool, idx) => (
                      <span 
                        key={idx}
                        className="px-3 py-1.5 bg-muted text-foreground text-xs md:text-sm rounded-md font-medium"
                      >
                        {tool}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProcessPhase;